import { useMemo } from 'react';
import type { PanelScreen } from '../../types/panelConfig';
import type { StokKaynak } from './useStokVerisi';

export const STOK_ANAHTARLARI = [
  'kayipOzet', 'kayipSeyir', 'kayipKategori', 'kayipUrun', 'kayipBelge', 'kayipCiro',
  'oluStokTur',
  'abc', 'abcDetay', 'sellThrough', 'stokGun', 'devirHizi', 'subeFark',
  'subeGuvenilirlik', 'envanter',
] as const;
// S352: yaslandirma / yaslandirmaDetay / oluStok / gmroi anahtarları ekran sözlüğünde durur ama OKUNMAZ
//   (kartları kaldırıldı; ölü stok artık oluStokTur'dan beslenir).
export type StokAnahtar = (typeof STOK_ANAHTARLARI)[number];
export type StokKaynaklari = Partial<Record<StokAnahtar, StokKaynak>>;

/**
 * Kaynaklar YALNIZ ekran sözlüğünden çözülür (menüden DEĞİL): ds'lerin 10'u `menude_gizli`,
 * menüde hiç görünmüyorlar. `PanelConfigController` rol izni olmayan ds'i sözlüğe hiç yazmaz →
 * `undefined` döner ve ilgili kart sessizce gizlenir.
 */
export function stokKaynaklari(screen: PanelScreen | undefined): StokKaynaklari {
  const k = screen?.kaynaklar ?? {};
  const cikti: StokKaynaklari = {};
  for (const ad of STOK_ANAHTARLARI) {
    const v = k[ad];
    if (v) cikti[ad] = v;
  }
  return cikti;
}

export function useStokKaynaklari(screen: PanelScreen | undefined): StokKaynaklari {
  return useMemo(() => stokKaynaklari(screen), [screen]);
}
